import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { combineEpics, createEpicMiddleware } from 'redux-observable';
import {
    createStore,
    applyMiddleware,
    combineReducers,
    compose,
    Middleware,
    Store,
    Reducer
} from 'redux';

// constants
import { DEV_TOOLS_CONFIG } from '@sitegen/build/config/env/dev-tools';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createApplicationStore = (reducers: Reducer[], rootEpics: any[]): Store => {
    const middleware: Middleware[] = [thunk];
    const epicMiddleware = createEpicMiddleware();

    const rootReducer = combineReducers(reducers);

    let composeEnhancers = compose;

    if (DEV_TOOLS_CONFIG.REDUX_LOGGER) {
        middleware.push(
            createLogger({
                collapsed: true
            })
        );
    }

    if (DEV_TOOLS_CONFIG.REDUX_EXTENTION) {
        composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;
    }

    const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middleware, epicMiddleware)));
    epicMiddleware.run(combineEpics(...rootEpics));

    return store;
};

export default createApplicationStore;
